import "./DataTable.scss";

export interface TableProps {
  headers: { title: string; width?: string; field: string }[];
  data: {}[];
}

export const DataTable = ({ headers = [], data = [] }: TableProps) => {
  return (
    <div className="DataTable">
      <table>
        <thead>
          <tr>
            {headers.map((header) => (
              <th key={header.field}> {header.title}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((tdata: any) => (
            <tr key={tdata._id}>
              {headers.map((header) => (
                <td
                  style={{ width: header.width ? header.width : "" }}
                  key={header.field}
                >
                  {tdata[header.field]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default DataTable;
